<template>
  <div class="vasion-white-background vasion-calc-height">
    <VasionSchedulersPage title="Data Import" />
  </div>
</template>

<script>
import VasionSchedulersPage from '@/components/shared/VasionSchedulersPage.vue';

export default {
  name: 'DataImport',
  components: {
    VasionSchedulersPage,
  },
  data: function () {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
